import React from "react";
import { useTranslation } from "react-i18next";
import { HiArrowLongRight } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";

import contact_bg from "../../assets/background/contact_bg.jpg";
import useInView from "../../hooks/useInView";
import { MAIN_ROUTES } from "../../utils/routes";

const ContactSection = () => {
  const { t } = useTranslation("contact");
  const [setRef, visible] = useInView({
    threshold: 0,
  });
  const navigate = useNavigate();

  return (
    <section className="relative overflow-hidden py-24">
      <div className="absolute inset-0 bg-[linear-gradient(135deg,#00d2ff_0%,#3a47d5_100%)]" />
      <div
        className="absolute inset-0 bg-cover bg-center opacity-30"
        style={{ backgroundImage: `url(${contact_bg})` }}
      />
      <div
        className={`relative z-10 mx-auto flex max-w-8xl flex-col items-center gap-10 px-4 text-center transition duration-700 sm:px-6 lg:px-8 ${
          visible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"
        }`}
        ref={setRef}
      >
        <div className="flex max-w-3xl flex-col gap-5">
          {t("section.subheader") ? (
            <p className="text-sm font-semibold uppercase tracking-[0.22em] text-white/80">
              {t("section.subheader")}
            </p>
          ) : null}
          <h2 className="text-4xl font-semibold tracking-tight text-white sm:text-5xl">
            {t("section.header")}
          </h2>
          <p className="text-base leading-8 text-sky-50 sm:text-lg">
            {t("section.body")}
          </p>
        </div>

        <button
          className="inline-flex items-center gap-3 rounded-full bg-white px-6 py-3 text-sm font-semibold text-slate-900 shadow-sm transition hover:bg-slate-100"
          onClick={() => navigate(MAIN_ROUTES.get("CONTACT").PATH)}
          type="button"
        >
          <span>{t("section.action")}</span>
          <HiArrowLongRight className="text-xl" />
        </button>
      </div>
    </section>
  );
};

export default ContactSection;
